var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Empty, Spin } from 'antd';
import { SchemaForm } from './schema-form';
import { makeControlMap, xflowDefaultControls } from './schema-form/control-map/index';
export var PanelBody = function (props) {
    var _a = props.schema, schema = _a === void 0 ? { tabs: [] } : _a, triggerUpdate = props.triggerUpdate, onFieldsChange = props.onFieldsChange, afterUpdatingCb = props.afterUpdatingCb, defaultControlRender = props.defaultControlRender, loading = props.loading, controlMapService = props.controlMapService, _b = props.defaultControls, defaultControls = _b === void 0 ? [] : _b;
    var controlMapCache = React.useMemo(function () {
        var controlMap = makeControlMap(__spreadArray(__spreadArray([], xflowDefaultControls, true), defaultControls, true));
        if (controlMapService) {
            controlMapService(controlMap);
        }
        return controlMap;
    }, [controlMapService, defaultControls]);
    if (loading) {
        return (React.createElement("div", { className: "".concat(props.prefixClz, "-body"), style: __assign(__assign({}, props.style), { display: 'flex', justifyContent: 'center', alignItems: 'center' }) },
            React.createElement(Spin, { spinning: true })));
    }
    return (React.createElement("div", { className: "".concat(props.prefixClz, "-body"), style: props.style },
        schema.tabs.length > 0 && (React.createElement(SchemaForm, { schema: schema, onFieldsChange: onFieldsChange, controlMap: controlMapCache, defaultControlRender: defaultControlRender, afterUpdatingCb: afterUpdatingCb, triggerUpdate: triggerUpdate })),
        schema.tabs.length === 0 && React.createElement(Empty, { style: { paddingTop: '64px' } })));
};
